import ServicePageTemplate from '../services/ServicePageTemplate';
import { servicePageData } from '../../mocks/servicePages';
const ElectricalPage = () => <ServicePageTemplate data={servicePageData['electrical']} />;
export default ElectricalPage;
